import "./about.css";
import { useState } from "react";
import Loader from "../../components/loader/Loader";

const About = () => {
  const [isLoading, setIsLoading] = useState(false);

  if (isLoading) return <Loader />;

  return (
    <section className="about">
      {/* About Section */}
      <section className="about__section">
        <h2>ABOUT</h2>
        <p>
          Survival Interactive is an independent game studio dedicated to
          creating immersive, action-packed gaming experiences. Founded by
          passionate developers and designers, we focus on survival and
          cooperative gameplay where every decision counts. Our projects combine
          intense combat, strategic exploration, and dynamic crafting systems to
          challenge players and keep them engaged for hours. With a growing
          community of dedicated gamers, we aim to deliver content that is both
          innovative and memorable, offering unique worlds that test skill,
          strategy, and teamwork.
        </p>
      </section>

      {/* Upcoming Game Section */}
      <section className="about__upcoming-game">
        <h2>Upcoming Game</h2>
        <div className="upcoming__game-card">
          <img
            src="/SurvivalInteractive.png"
            alt="Upcoming Game"
            className="upcoming__game-image"
          />
          <div className="upcoming__game-info">
            <h3>Coming Soon...</h3>
            <p>
              <strong>Publisher:</strong> Survival Interactive
            </p>
            <p>
              <strong>Developer:</strong> Survival Interactive
            </p>
            <p>
              <strong>Release:</strong> TBA
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact__section">
        <div className="contact__content">
          <h2>Contact With Us</h2>
          <p>
            Have questions, need support, or want to follow our updates? We're
            here to help.
          </p>

          <div className="contact__links">
            {/* Email Card */}
            <div className="contact__card">
              <h3>Email</h3>
              <a href="mailto:survivalinteractiveco@gmail.com">
                survivalinteractiveco@gmail.com
              </a>
            </div>

            {/* YouTube Card */}
            <div className="contact__card">
              <h3>YouTube</h3>
              <a
                href="https://www.youtube.com/@SurvivalInteractive"
                target="_blank"
                rel="noreferrer"
              >
                @SurvivalInteractive
              </a>
            </div>

            {/* LinkedIn Card */}
            <div className="contact__card">
              <h3>LinkedIn</h3>
              <a
                href="https://www.linkedin.com/company/survival-interactive/"
                target="_blank"
                rel="noopener noreferrer"
              >
                @SurvivalInteractive
              </a>
            </div>

            {/* Official Forums Card */}
            <div className="contact__card">
              <h3>Official Forums</h3>
              <a
                href="https://www.survivalinteractive.com/forum"
                target="_blank"
                rel="noopener noreferrer"
              >
                Forums
              </a>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};

export default About;
